export default __webpack_public_path__ + "static/media/arrowupward.55f3f9ff.svg";